"use client";

import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
import { Facebook, Instagram, Twitter, Linkedin } from "lucide-react";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
        <div className="h-5 w-20 bg-muted-light-background animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false} className="block">
      <NavigationMenuList className="flex-col items-start gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-foreground-dark hover:text-primary transition-colors duration-[var(--duration-fast)] relative after:absolute after:bottom-0 after:left-0 after:h-[2px] after:w-0 after:bg-primary after:transition-all after:duration-[var(--duration-medium)] hover:after:w-full">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  const socialLinks = [{
    icon: Facebook,
    href: "https://facebook.com",
    label: "Facebook"
  }, {
    icon: Instagram,
    href: "https://instagram.com",
    label: "Instagram"
  }, {
    icon: Twitter,
    href: "https://twitter.com",
    label: "Twitter"
  }, {
    icon: Linkedin,
    href: "https://linkedin.com",
    label: "LinkedIn"
  }];
  return <footer id="footer" className="bg-dark-background text-foreground-dark py-12 px-6">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          <div className="flex flex-col gap-6">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1542870/img/equicanine_footer_logo.png" alt="EquiCanine Logo" className="h-7" />
            <p className="text-sm text-muted">
              Professional care for horses and dogs in a spacious rural facility.
            </p>
          </div>

          <div>
            <h3 className="font-display font-semibold text-lg mb-4 text-foreground-dark">
              Navigation
            </h3>
            <MenuProvider menu_id="79">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>

          <div>
            <h3 className="font-display font-semibold text-lg mb-4 text-foreground-dark">
              Connect With Us
            </h3>
            <div className="flex gap-4">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} data-index={i} newTab className="w-10 h-10 rounded-full bg-primary/20 flex items-center justify-center text-foreground-dark hover:bg-primary hover:text-white hover:rotate-6 hover:scale-110 transition-all duration-[var(--duration-fast)] ease-[var(--ease-spring)]" aria-label={social.label}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-muted/20 text-center text-sm text-muted">
          <p>&copy; 2024 EquiCanine. All rights reserved.</p>
        </div>
      </div>
    </footer>;
}